import { FileUp, ImagePlus, Type } from 'lucide-react';
import { useState } from 'react';
import { COPY } from '@/content/copy';
import type { AssetRole, EditorPort, EditorSnapshot } from '@/ports/editor';

export function AddPanel({ editor, snapshot, onImport, onTextAdded }: { readonly editor: EditorPort; readonly snapshot: EditorSnapshot; readonly onImport: (role: AssetRole) => void; readonly onTextAdded: (id: string) => void }) {
  const [text, setText] = useState('Tu marca');
  const addText = async () => {
    const value = text.trim();
    if (!value) return;
    const id = await editor.addText(value);
    onTextAdded(id);
  };
  const sticker = snapshot.document?.product.kind === 'sticker';

  return (
    <div className="panel-stack" data-testid="add-panel">
      <section className="add-section">
        <div className="add-section__heading"><Type /><div><strong>{COPY.textAndSettings}</strong><small>Agregá el texto y después elegí tipografía, color, contorno, tamaño y rotación.</small></div></div>
        <label htmlFor="new-text">Texto a agregar</label>
        <div className="inline-compose">
          <input id="new-text" value={text} placeholder={COPY.textPlaceholder} onChange={(event) => setText(event.target.value)} />
          <button type="button" onClick={() => void addText()}>+ Agregar texto</button>
        </div>
      </section>

      <section className="add-section">
        <div className="add-section__heading"><ImagePlus /><div><strong>{sticker ? '1. Subí la imagen del sticker' : COPY.uploadLogo}</strong><small>{COPY.imageFormats}</small></div></div>
        <div className="file-action-grid is-single">
          <button type="button" onClick={() => onImport(sticker ? 'sticker-image' : 'logo')}><FileUp /> Subir imagen o PDF</button>
        </div>
      </section>
    </div>
  );
}
